import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Eyebrow } from '../components/primitives';

export function AuthFrame({
  eyebrow,
  title,
  subtitle,
  children,
  footer,
}: {
  eyebrow?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="mx-auto flex min-h-screen w-full max-w-md flex-col px-5 pb-10 pt-8 lg:pt-16">
      <Link to="/welcome" className="font-display text-lg font-semibold text-ink">
        Miracles Protocol
      </Link>
      <div className="mt-12">
        {eyebrow && <Eyebrow className="mb-3">{eyebrow}</Eyebrow>}
        <h1 className="font-display text-[2rem] font-semibold leading-[1.1] text-ink">{title}</h1>
        {subtitle && (
          <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{subtitle}</p>
        )}
      </div>
      <div className="mt-8">{children}</div>
      {footer && <div className="mt-8 text-sm text-muted-foreground">{footer}</div>}
    </div>
  );
}
